export enum RuntimeProfile {
    Daily = 'Daily',
    Weekly = 'Weekly',
    FullTime = 'FullTime',
}
